import React from 'react';
import { Button } from './ui/button';
import { EcosystemDock } from './EcosystemDock';

export const DashboardBottomDock = ({ onRequestScholarship }) => {
  return (
    <div className="space-y-3" data-testid="dashboard-bottom-dock">
      {/* Scholarship CTA - moved to bottom */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 bg-gradient-to-r from-amber-900/15 to-transparent border border-amber-500/20 rounded-2xl px-4 py-2">
        <div>
          <p className="text-[13px] text-amber-200" data-testid="scholarship-bottom-cta">
            Need financial assistance? Request a scholarship to access premium features.
          </p>
        </div>
        <Button
          onClick={onRequestScholarship}
          className="bg-amber-600 hover:bg-amber-500 text-black font-semibold rounded-xl"
          size="sm"
          data-testid="scholarship-bottom-button"
        >
          Request Scholarship
        </Button>
      </div>

      {/* Sacred Ecosystem - compact circular dock */}
      <div className="flex items-center justify-center" data-testid="sacred-ecosystem-bottom">
        <EcosystemDock includeDefiance={true} />
      </div>
    </div>
  );
};
